var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15,
    viewBox: "0 0 15.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #979797;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1 {\n        stroke-linecap: square;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3_Copy",
    "data-name": "Group 3 Copy",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    className: "cls-1",
    d: "M.5.5h10",
    transform: "translate(4 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    className: "cls-1",
    d: "M.5.5h10",
    transform: "translate(4 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_Copy",
    "data-name": "Line Copy",
    className: "cls-1",
    d: "M.5.5h10",
    transform: "translate(4 8.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_Copy_2",
    "data-name": "Line Copy 2",
    className: "cls-1",
    d: "M.5.5h10",
    transform: "translate(4 12.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-2",
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    className: "cls-2",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    className: "cls-2",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0 8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_4",
    "data-name": "Oval Copy 4",
    className: "cls-2",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListView);
export default __webpack_public_path__ + "static/media/icon-list-view.6791326e1a16f0efefbcf7922960ea53.svg";
export { ForwardRef as ReactComponent };